export default "__VITE_ASSET__nSe8peRO__"